import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchSeasonApiClient extends AdvancedApiClient {

    static entityType = "FarfetchSeason"

    constructor(token, channelId) {
        super();

        this.setEntityType(FarfetchSeasonApiClient.entityType)
            .setRoute("/api/v1/channel/{id}/farfetch/season")
            .setRouteParam("id", channelId);
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}